import React from "react";

const Label = ({ htmlFor, text, className = "", ...props }) => {
  return (
    <label
      htmlFor={htmlFor}
      className={`block mb-1 pl-0 text-[14px] font-medium text-gray-700 ${className}`}
      {...props}
    >
      {text}
    </label>
  );
};

export default Label;
